import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Container,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Card,
  CardBody,
} from "reactstrap";
import classnames from "classnames";
import api from "../../api";
import RateListManagement from "../../components/Moderator/RateListManagement";
import PokemonToEconomy from "../../components/Moderator/PokemonToEconomy";

const ModeratorPanel = () => {
  document.title = "Pokemon Radiance | Moderator Panel";
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("ratelist");
  const [isModerator, setIsModerator] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check if the user is a moderator
    const checkModeratorStatus = async () => {
      try {
        const response = await api.get("/v1/moderator/rank", {
          headers: { Accept: "application/json" },
          withCredentials: true,
        });

        if (response.data.length > 0 && response.data[0].adm === 4) {
          setIsModerator(true);
        } else {
          navigate("/dashboard");
        }
      } catch (error) {
        console.error("Failed to check moderator status:", error);
        navigate("/dashboard");
      } finally {
        setLoading(false);
      }
    };

    checkModeratorStatus();
  }, [navigate]);

  if (loading) return <p>Loading...</p>;

  return (
    <Container
      fluid
      style={{
        marginTop: "80px",
        paddingTop: "20px",
      }}
    >
      <h2 className="mb-4">Moderator Panel</h2>
      
      {/* Navigation Tabs */}
      <Nav tabs>
        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === "ratelist" })}
            onClick={() => setActiveTab("ratelist")}
            style={{ cursor: "pointer" }}
          >
            RateList Management
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === "pokemon" })}
            onClick={() => setActiveTab("pokemon")}
            style={{ cursor: "pointer" }}
          >
            Add Pokemon to Economy
          </NavLink>
        </NavItem>
      </Nav>

      {/* Tab Content */}
      <TabContent activeTab={activeTab} className="mt-3">
        <TabPane tabId="ratelist">
          <Card>
            <CardBody>
              <RateListManagement />
            </CardBody>
          </Card>
        </TabPane>
        
        <TabPane tabId="pokemon">
          <Card>
            <CardBody>
              <PokemonToEconomy />
            </CardBody>
          </Card>
        </TabPane>
      </TabContent>
    </Container>
  );
};

export default ModeratorPanel;
